export default "/static/images/build_roof_11.png?13d54258a82806c6fdcb53c6124a5a6b";